import { ADD_KLAUSUR } from "./types";

export function addKlausurDummy(data) {
  // console.log({data})
  return async function (dispatch) {
    const klausur = { ...data };
    return dispatch(addKlausur(klausur));
  };
}
function addKlausur(klausur) {
  return {
    type: ADD_KLAUSUR,
    klausur,
  };
}

export function getKlausurFromFile(klausur) {
  return async function (dispatch) {
    return dispatch(addKlausur(klausur));
  };
}


